import React, {useState} from "react";
import {useMutation, useQuery} from "@apollo/client";
import {useNavigate, useParams} from "react-router-dom";
import {Button, Col, Container, Row} from "react-bootstrap";
import FlashMessage from "../../shared/FlashMessage";
import {saveData} from "../../../helpers/Api";
import {createMenuMutation, getMenuById, updateMenuMutation} from "./MenuQueries";
import MenuPlatesList from "./MenuPlatesList";
import PageTitle from "../../../layout/PageTitle";
import {BackButton} from "../../../helpers/ButtonHelper";
import UploadFile from "../../shared/UploadFile";

const MenuForm = () => {
  const params = useParams();
  const navigate = useNavigate()
  const [flash, setFlash] = useState({});
  const [menu, setMenu] = useState({
    id: '',
    name: '',
    description: '',
    image: '',
    menus: []
  })
  const {loading, data, refetch} = useQuery(getMenuById, {variables: {id: params.id}})

  let mutation = createMenuMutation;
  let response_key = 'createMenu'

  if (params.id) {
    mutation = updateMenuMutation
    response_key = 'updateMenu'

    if (!menu.id && !loading && data)
      setMenu(data.menu)
  }
  const [saveCall] = useMutation(mutation)

  const onSubmit = (event) => {
    event.preventDefault()
    saveData({
      event: event,
      gqlCall: saveCall,
      query_key: response_key,
      flash_callback: setFlash,
      success: (res) => {
        if (!params.id)
          navigate(`/menus/${res.menu.id}`)
      }
    })
  }

  return (
    <>
      <Container>
        {!params.id ?
          <PageTitle title='Adauga meniu'/>
          :
          <PageTitle title={`Modifica meniul ${menu.clientId ? `pentru clientul ${menu.client.fullName}` : ''} `}/>
        }
        <Row className='d-sm-flex mb-4 mt-4 align-items-start'>
          <Col className='flex-shrink-0 me-2 col-auto p-2'>
            {menu.id &&
              <UploadFile model='menu' id={menu.id} item={menu} field='image'
                          filePath={menu.image} onChange={refetch}/>}
          </Col>
          <Col>
            <form onSubmit={onSubmit}>
              <input type='hidden' name='id' id="id" defaultValue={menu.id}/>

              <Row className="mb-2">
                <Col>
                  <label htmlFor="name">Denumire</label>
                  <input type='text' name='name' className="form-control" id="name" defaultValue={menu.name}/>
                </Col>
              </Row>

              <Row className='mb-2'>
                <Col>
                  <label htmlFor="details">Descriere</label>
                  <textarea name='details' className="form-control" id="details" defaultValue={menu.details}/>
                </Col>
              </Row>

              <Row className="mb-3">
                <FlashMessage flash={flash} buttons={
                  <>
                    {menu.clientId ?
                      <BackButton to={`/clients/${menu.clientId}`} className='float-end' showText={true} size='md'/>
                      :
                      <BackButton to='/menus' className='float-end' showText={true} size='md'/>
                    }
                    <Button type='submit' className='float-end'>Salveaza</Button>
                  </>
                }/>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
      {menu && menu.id &&
        <MenuPlatesList menu={menu}></MenuPlatesList>
      }
      <div className='mb-3'></div>
    </>
  )
};

export default MenuForm;